export default __webpack_public_path__ + "static/media/three.e7994ba3.svg";